import { render, staticRenderFns } from "./bodyTable.vue?vue&type=template&id=ef687fbc"
import script from "./bodyTable.vue?vue&type=script&lang=js"
export * from "./bodyTable.vue?vue&type=script&lang=js"
import style0 from "./bodyTable.vue?vue&type=style&index=0&id=ef687fbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports